import React from "react";

import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";

import { useController, useFormContext, useWatch } from "react-hook-form";
import TimeTable from "../../../components/TimeTable/TimeTable";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";

function MenukaartTimeTable() {
  const { control } = useFormContext();
  const { field } = useController({ control, name: "timeTable" });
  const timeTableValue = useWatch({ name: "timeTable" });

  return (
    <Card>
      <CardBody>
        <h5>
          <TranslationWrapper
            tKey={
              "This category is visible at these times. Category is always visible when data is empty for all days."
            }
          />
        </h5>
        <TimeTable
          data={timeTableValue}
          inputName={"timeTable"}
          onChange={(value) => {
            if (value != null && Object.keys(value).length === 0) {
              field.onChange(null);
            } else {
              field.onChange(JSON.stringify(value));
            }
          }}
          // showMaxItems
        />
      </CardBody>
    </Card>
  );
}

export default MenukaartTimeTable;
